<template>
  <section id="home" class="hero">
    <div class="container hero-container">
      <div class="hero-content">
        <h1 class="hero-title">河北致鑫环境科技有限公司</h1>
        <p class="hero-subtitle">
          专注于技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；<br />
          提供软件开发、软件销售、大数据服务、数字技术服务、数据处理服务；<br />
          致力于环境保护专用设备销售、包装材料及制品销售、五金产品零售、日用百货销售；<br />
          拥有城市生活垃圾经营性服务资质。
        </p>
        <div class="hero-buttons">
          <a href="#services" class="btn btn-primary">了解服务</a>
          <a href="#contact" class="btn btn-outline">联系我们</a>
        </div>
      </div>
      <div class="hero-image">
        <img src="@/assets/zhixin.png" alt="河北致鑫环境科技有限公司" class="hero-img" />
      </div>
    </div>
    <div class="wave-divider">
      <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="currentColor"></path>
        <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="currentColor"></path>
        <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="currentColor"></path>
      </svg>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppHero'
};
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #1E5AA8 0%, #0A2647 100%);
  color: white;
  padding: 6rem 2rem 4rem;
  position: relative;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.hero-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4rem;
}

.hero-content {
  flex: 1;
  max-width: 600px;
}

.hero-title {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 2.5rem;
  opacity: 0.9;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn {
  display: inline-block;
  padding: 0.875rem 2rem;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 1rem;
  cursor: pointer;
  border: 2px solid transparent;
  text-align: center;
}

.btn-primary {
  background-color: #FF6B35;
  color: white;
}

.btn-primary:hover {
  background-color: #e55a2b;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(255, 107, 53, 0.3);
}

.btn-outline {
  background-color: transparent;
  color: white;
  border-color: white;
}

.btn-outline:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.hero-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-img {
  max-width: 100%;
  max-height: 400px;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  object-fit: contain;
}

.wave-divider {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.wave-divider svg {
  display: block;
  width: calc(100% + 1.3px);
  height: 120px;
  transform: rotate(180deg);
}

.wave-divider path {
  fill: #ffffff;
}

@media (max-width: 992px) {
  .hero-container {
    flex-direction: column;
    text-align: center;
    gap: 3rem;
  }
  .hero-title {
    font-size: 2.5rem;
  }
  .hero-subtitle {
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .hero {
    padding: 5rem 1.5rem 3rem;
  }
  .hero-title {
    font-size: 2rem;
  }
  .hero-subtitle {
    font-size: 1rem;
  }
  .hero-buttons {
    justify-content: center;
  }
}
</style>
